import {
    apiRequest,
    AcTeknisCreate,
    AcTeknisEmployee,
    AcTeknisPeriod,
    AcTeknisKinerja,
    AcTeknisStankom,
    AcTeknisEmployeeDetail,
    AcTeknisLevelCompetence
} from "../../../../../services/adapters/Assesment/assesmentService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", AcTeknisCreate, {
            body: query
        }, true)
    }

    // fetchCategories = async (query) => {
    //     return await apiRequest("get", masterCategories, {
    //         params: query
    //     }, true)
    // }
    fetchEmployee = async (query) => {
        return await apiRequest("get", AcTeknisEmployee, {
            params: query
        }, true)
    }
    fetchPeriod = async (query) => {
        return await apiRequest("get", AcTeknisPeriod, {
            params: query
        }, true)
    }
    fetchPerformance = async (query) => {
        return await apiRequest("get", AcTeknisKinerja, {
            params: query
        }, true)
    }
    fetchStankom = async (query) => {
        return await apiRequest("get", AcTeknisStankom, {
            params: query
        }, true)
    }
    fetchDetailEmployee = async (query) => {
        return await apiRequest("get", AcTeknisEmployeeDetail, {
            params: query
        }, true)
    }
    fetchStankom = async (query) => {
        return await apiRequest("get", AcTeknisStankom, {
            params: query
        }, true)
    }
    fetcLevelCompetence = async (query) => {
        return await apiRequest("get", AcTeknisLevelCompetence, {
            params: query
        }, true)
    }
}

export default CreateRepository